var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2849_1259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9051 32.7163C36.1098 32.7163 35.4651 33.3879 35.4651 34.2163C35.4651 35.0447 36.1098 35.7163 36.9051 35.7163V32.7163ZM2.62848 11.5C1.83318 11.5 1.18848 12.1716 1.18848 13C1.18848 13.8284 1.83318 14.5 2.62848 14.5V11.5ZM43.9265 32.7163H36.9051V35.7163H43.9265V32.7163ZM45.1397 31.4489C45.1397 32.1507 44.5948 32.7163 43.9265 32.7163V35.7163C46.1889 35.7163 48.0197 33.8039 48.0197 31.4489H45.1397ZM45.1397 15.7673V31.4489H48.0197V15.7673H45.1397ZM43.9265 14.5C44.5948 14.5 45.1397 15.0655 45.1397 15.7673H48.0197C48.0197 13.4124 46.1889 11.5 43.9265 11.5V14.5ZM2.62848 14.5H43.9265V11.5H2.62848V14.5Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26488 35.3329V19.7852H3.53966L0.5 22.5367V25.5938L3.53966 22.8424V35.3329H6.26488Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2469 35.333V32.7781H14.4821L18.6538 27.7339C19.681 26.4892 20.2469 25.6812 20.2469 24.1745C20.2469 21.3794 18.3602 19.6543 15.7189 19.6543C13.1614 19.6543 11.1699 21.3576 11.1699 24.1963H13.8951C13.8951 22.6896 14.8174 22.2092 15.7189 22.2092C16.8718 22.2092 17.5218 22.9953 17.5218 24.1527C17.5218 24.8733 17.2912 25.3537 16.7461 26.0306L11.1699 32.7781V35.333H20.2469Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9016 30.8347C31.9016 28.9567 31.0421 27.8867 29.9731 27.2971C30.9583 26.7512 31.692 25.7904 31.692 24.109C31.692 21.4886 29.7843 19.6543 27.143 19.6543C24.6274 19.6543 22.6359 21.3139 22.573 24.0872H25.2982C25.3611 22.908 26.1158 22.2092 27.143 22.2092C28.1282 22.2092 28.9668 22.8861 28.9668 24.1963C28.9668 25.2882 28.4008 26.1398 27.0801 26.1398H26.6818V28.6073H27.0801C28.4217 28.6073 29.1764 29.459 29.1764 30.7473C29.1764 32.1449 28.3379 32.9092 27.164 32.9092C26.0948 32.9092 25.1725 32.2759 25.1305 30.8784H22.4053C22.4472 34.132 24.7322 35.4641 27.164 35.4641C29.7214 35.4641 31.9016 33.9355 31.9016 30.8347Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2849_1259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.1eb83a49e02600cdaa69bb4c1409ebb2.svg";
export { ForwardRef as ReactComponent };